module.exports = __webpack_public_path__ + "static/media/banner3.b3036323.png";